export default "/_next/static/images/062fd1be3523c7853df14ade52880651.png";